
































import UserList from '@/components/admin/users/List.vue'
import MessageUser, { IMessageUser } from '@/models/MessageUser'
import axios from 'axios'
import Message, { IMessage } from '@/models/Message'
import User from '@/models/User'
import { apiV1AdminMessageMessageUsersPath, apiV1AdminMessagePath, apiV1AdminUsersPath } from '@/rails/routes'
import { Component } from 'vue-property-decorator'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import {saveAs} from 'file-saver'
import * as dayjs from 'dayjs'
import {KeyPair} from '@/types/KeyPair'
import UserListCondition from '@/models/shared/UserListCondition'

@Component(
  {
    components: {
      UserList
    }
  }
)
export default class MessageShow extends PageBase {
  message: Message = new Message()
  users: Array<User> = []
  panels = [1]
  additionalHeaders = [
    { text: '送信結果', value: 'sentResult', width: 100 }
  ]
  userListCondition = new UserListCondition()
  usersCount = 0
  errorMessageUsers: Array<MessageUser> = []

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'メルマガ一覧',
        to: '/admin/messages',
        exact: true
      },
      {
        text: 'メルマガ詳細'
      }
    ]
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const res = await axios.get<IMessage>(apiV1AdminMessagePath(this.$route.params.id))
      this.message = new Message(res.data)
      await this.reloadUsers()
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async reloadUsers(): Promise<void> {
    try {
      this.showLoading()
      const users = await axios.get(apiV1AdminUsersPath(this.userSearchParams()))
      this.users = users.data.list.map(u => new User(u))
      this.userListCondition.pagenate = users.data.pagenate
      this.usersCount = users.data.pagenate.all_count
      const messageUsers = await axios.get<Array<IMessageUser>>(apiV1AdminMessageMessageUsersPath(this.$route.params.id, {
        q: {
          error_not_null: true
        }
      }))
      this.errorMessageUsers = messageUsers.data.map(mu => new MessageUser(mu))
      this.hideLoading()
    } catch (e) {
      console.error(e)
    }
  }

  async download(): Promise<void> {
    try {
      this.showLoading()
      const res = await axios.get(apiV1AdminUsersPath(this.userSearchParams('xlsx')),
        {
          responseType: 'blob'
        })
      const blob = new Blob([res.data])
      saveAs(blob, `users_${dayjs().format('YYYYMMDD_HHmm')}.xlsx`)
      this.hideLoading()
    } catch (e) {
      console.error(e)
    }
  }

  userSearchParams(format?: string): KeyPair {
    const params = this.userListCondition.toParams()
    params['q'] = {
      messages_id_eq: this.$route.params.id
    }

    if (format) {
      params['format'] = format
    }
    return params
  }

  findError(user: User): MessageUser {
    return this.errorMessageUsers.find(em => em.user_id === user.id) || new MessageUser()
  }
}
